import { useTranslation } from "react-i18next";
import LeafDonutChart from "../../../../common/leaf/LeafCharts/LeafDonutChart/LeafDonutChart";
import defaultContent from "../../../../content/earningsCalculator";
import "./EarningsCalculatorDonutChart.scss";
import { PercentageEntry } from "../../../../services/EarningsCalculator/earningCalculatorAPI.types";

type Props = {
  isLoading: boolean;
  percentage: PercentageEntry[];
};
const EarningsCalculatorDonutChart = (props: Props) => {
  const { isLoading, percentage } = props;
  const { t } = useTranslation(["earningsCalculator"]);

  return (
    <div className="earnings-calculator-donut-chart">
      <LeafDonutChart
        isLoading={isLoading}
        content={[
          {
            Label: "PerfBonusTotal",
            Text: `${t(
              "incomeBreakdownTile.performanceBonusTotal.title",
              defaultContent["incomeBreakdownTile"]["performanceBonusTotal"]["title"],
            )}`,
            Color: "#ce4800",
          },
          {
            Label: "BronzeFoundation",
            Text: `${t(
              "incomeBreakdownTile.bronze.bfi.title",
              defaultContent["incomeBreakdownTile"]["bronze"]["bfi"]["title"],
            )}`,
            Color: "#445685",
          },
          {
            Label: "CSI",
            Text: `${t("incomeBreakdownTile.csi.title", defaultContent["incomeBreakdownTile"]["csi"]["title"])}`,
            Color: "#5969D6",
          },
          {
            Label: "BronzeBuilder",
            Text: `${t(
              "incomeBreakdownTile.bronze.bbi.title",
              defaultContent["incomeBreakdownTile"]["bronze"]["bbi"]["title"],
            )}`,
            Color: "#007775",
          },
        ]}
        data={percentage}
      />
    </div>
  );
};

export default EarningsCalculatorDonutChart;
